import React, { useEffect, useMemo, useRef, useState } from "react";
import { Select, Table, Tag, DatePicker } from "antd";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import {
  formatDate,
  getCurrentFormattedDate,
} from "core/Operations/dateFormat";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, PlusCircle } from "react-feather";
import { all_routes } from "Router/all_routes";
import ReportTools from "Components/UI/ReportTools";
import { useEmployeeAdvanceRePaymentList } from "AppQuries/report/get-advance-repayment-report";
import dayjs from "dayjs";
import { format, startOfMonth, endOfMonth } from "date-fns";
import { useFormattedEmployees } from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import { BackIcon } from "Components/UI/Icon/Icons";
const { RangePicker } = DatePicker;
const AdvanceRePaymentReport = () => {
  console.log("AdvanceRePaymentReport");
  const userData = useSelector(loggedInUser);
  const [queryParams, setQueryParams] = useState({
    employeeCode: 0,
    fromDate: format(startOfMonth(new Date()), "yyyy-MM-dd"),
    toDate: format(endOfMonth(new Date()), "yyyy-MM-dd"),
  });
  const {
    data,
    advancePaymentList: isAdvancePaymentListLoading,
    isError,
    error,
    refetch: getAdvancePaymentData,
  } = useEmployeeAdvanceRePaymentList(
    {
      companyCode: userData?.companyCode,
      locationCode: userData?.selectedLocationCode,
      userId: userData?.userID,
      isAllCompanies: userData?.isAllCompanies,
      selectedCompanyCode: userData?.selectedCompanyCode,
      ...queryParams,
    },
    {
      enabled: Boolean(
        queryParams.employeeCode &&
        queryParams.fromDate &&
        queryParams.toDate &&
        userData?.companyCode &&
        userData?.locationCode,
      ),
    },
  );

  const employeeOptions = useFormattedEmployees({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    departmentCode: 0,
  });

  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [updateModalVisible, setUpdateModalVisible] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(true);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };
  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
    },
    {
      title: "Emp Name",
      dataIndex: "employeeName",
    },
    {
      title: "Department",
      dataIndex: "departmentName",
    },
    {
      title: "Advance Date",
      dataIndex: "advanceDate",
      //   render: (text, record) => format(new Date(text), "dd-MM-yyyy"),
    },
    {
      title: "Amount",
      dataIndex: "advanceAmount",
    },
    // {
    //   title: "Repayment Date",
    //   dataIndex: "repaymentDate",
    //   //   render: (text, record) => format(new Date(text), "dd-MM-yyyy"),
    // },
    // {
    //   title: "Approved",
    //   dataIndex: "isApproved",
    // },
    // { title: "Approved By", dataIndex: "approvedBy" },
    // { title: "Approved Date", dataIndex: "approvalDate" },
    { title: "Repayment Start", dataIndex: "repaymentStartDate" },
    { title: "Repayment End", dataIndex: "repaymentEndDate" },
    {
      title: "Paid Amount",
      dataIndex: "paidAmount",
    },
    {
      title: "Balance Amount",
      dataIndex: "balanceAmount",
    },
  ];

  const advancePaymentList = useMemo(
    () =>
      data?.map((d, i) => ({
        ...d,
        id: i,
        advanceDate: formatDate(d.advanceDate, "dd-MM-yyyy"),
        advanceAmount: Number(d.advanceAmount).toFixed(2),
        approvalDate: formatDate(d.approvalDate, "dd-MM-yyyy"),
        // repaymentStartDate: formatDate(d.repaymentStartDate, "dd-MM-yyyy"),
        // repaymentEndDate: formatDate(d.repaymentEndDate, "dd-MM-yyyy"),
        paidAmount: Number(d.paidAmount).toFixed(2),
        balanceAmount: Number(d.balanceAmount).toFixed(2),
      })),
    [data],
  );

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    advancePaymentList,
    searchColumns,
  );

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Employee Advance Payment Details</h4>
              <h6>View and manage advance payments</h6>
            </div>
          </div>
          <div className="page-btn">
            <ReportTools
              data={advancePaymentList}
              columns={columns}
              fileName="Advance Payment Report"
            />
          </div>
          <div className="page-btn">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
            >
              <Link
                to={`${all_routes.report_list}`}
                className="btn btn-secondary"
              >
                <BackIcon className="me-2" />
                Back
              </Link>
            </OverlayTrigger>
          </div>
        </div>
        <div className="card border-0">
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <div className="table-list-card">
                  <TableTop
                    onSearch={setSearchValue}
                    toggleFilterVisibility={toggleFilterVisibility}
                    showToggle={true}
                    isFilterVisible={isFilterVisible}
                  />
                  <div
                    className={`card${isFilterVisible ? " visible" : ""}`}
                    id="filter_inputs"
                    // style={{ display: isFilterVisible ? "block" : "none" }}
                  >
                    <div className="card-body pb-0">
                      <div className="form-row row">
                        <div className="row">
                          <div className="col-lg-3 col-sm-6 col-12 mb-3">
                            <div className="" style={{ display: "flex" }}>
                              <div className="form-group">
                                <label className="form-label">
                                  Start Date – End Date
                                </label>
                                <RangePicker
                                  //   className="form-control"
                                  placeholder="From Date"
                                  onChange={(date, dateString) => {
                                    if (date) {
                                      updateQueryParams(
                                        "fromDate",
                                        dateString[0],
                                      );
                                      updateQueryParams(
                                        "toDate",
                                        dateString[1],
                                      );
                                    }
                                  }}
                                  defaultValue={[
                                    dayjs(queryParams?.fromDate, "YYYY-MM-DD"),
                                    dayjs(queryParams?.toDate, "YYYY-MM-DD"),
                                  ]}
                                  dateFormat="YYYY-MM-DD"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-3 col-sm-6 col-12 mb-3">
                            <label className="form-label">Employee</label>
                            <Select
                              className="form-control"
                              options={employeeOptions}
                              placeholder="Select Employee"
                              value={
                                employeeOptions.find(
                                  (option) =>
                                    option.value === queryParams.employeeCode,
                                ) || ""
                              }
                              onChange={(e) => {
                                updateQueryParams("employeeCode", e || 0);
                              }}
                              onClear={(e) => {
                                updateQueryParams("employeeCode", 0);
                              }}
                              allowClear
                              showSearch
                              optionFilterProp="label"
                              variant="borderless"
                              style={{ width: "100%" }}
                            />
                          </div>

                          <div className="col-lg-1 col-sm-6 col-12">
                            <div className="input-blocks">
                              <label className="form-label">&nbsp;</label>
                              <Link
                                className="btn btn-filters ms-auto"
                                onClick={getAdvancePaymentData}
                                type="button"
                              >
                                <i
                                  data-feather="search"
                                  className="feather-search"
                                />
                                <>Filter</>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <Table
                      loading={isAdvancePaymentListLoading}
                      columns={columns}
                      dataSource={filteredData}
                      rowKey={(record) => record.uniqueID}
                      pagination={true}
                      bordered
                      // scroll={{ x: 1500 }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvanceRePaymentReport;
